import { useStore } from "zustand";
import { createStore } from "zustand/vanilla";

import { persistStore } from "./persistStore";

export type AuthState = {
  isInitialAuthCheckCompleted: boolean;
};

type AuthStateActions = {
  completeInitialAuthCheck: () => void;
};

export const initialAuthState: AuthState = {
  isInitialAuthCheckCompleted: false,
};

export const authStateStore = createStore<AuthState & { actions: AuthStateActions }>()((set) => ({
  ...initialAuthState,
  actions: {
    completeInitialAuthCheck: () => set({ isInitialAuthCheckCompleted: true }),
  },
}));

persistStore(
  authStateStore,
  {
    key: "persist:authState",
    legacyReduxPersistVersion: -1,
    fields: ["isInitialAuthCheckCompleted"],
    storage: "session",
  },
  initialAuthState
);

export const useIsInitialAuthCheckCompleted = () =>
  useStore(authStateStore, (state) => state.isInitialAuthCheckCompleted);
